import React, { memo, useCallback } from "react";
import stylesPc from "./FeaturedContentCard.module.css";
import stylesSp from "./FeaturedContentCard_SP.module.css";
import { IsDevice } from "../../../../components/function/useDeviceFlag";
import { useHistory } from "react-router-dom";
// import { SpacedList, SpacedListItem } from "../../../../common/components/spacedList/SpacedList";
// import { VideoTag } from "../../../../common/video/models/VideoTag";
// import Tag from "../../../../common/components/tag/Tag";
import VideoMenu from "../../../../common/components/videoMenu/VideoMenu";
import EditVideoPage from "../../../../common/components/videoMenu/EditVideo";
import PuiTooltip from "../../../../components/elements/PuiTooltip ";
import PuiTypography from "../../../../components/elements/PuiTypography";
import EditSlideStock from "../../../videoPlayer/components/slideStockEdit/EditSlideStock";
import { useInitFlag } from "../../../../components/function/useInitFlag";

interface ContentCardProps {
    content: any;
    setMsg: (msg: string) => void;
}

function FeaturedContentCard({ content, setMsg }: ContentCardProps) {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : stylesSp;

    const history = useHistory();
    const [isShowMenu, setShowMenu] = useInitFlag();

    const goToContent = useCallback(() => {
        if (content.fileType) {
            history.push(`/slidestock/${content.id}`);
        } else {
            history.push(`/video/${content.id}`);
        }
    }, [content, history]);

    return (
        <div className={styles.card}>
            <div className={styles.thumbnaildiv}>
                <img
                    className={styles.thumbnail}
                    src={content.imageUrl}
                    alt=""
                    onClick={goToContent}
                    onError={(e) =>
                        (e.currentTarget.src = require("../../../../assets/image/NoImage.jpg"))
                    }
                />

                {/* ビデオ編集ボタン */}
                {!content.fileType && (
                    <div className={styles.editVideoIcon}>
                        <EditVideoPage videoId={content.id} />
                    </div>
                )}

                {/* コンテンツ編集ボタン表示 */}
                {content.fileType && (
                    <div className={styles.editVideoIcon}>
                        <EditSlideStock slideId={content.id} />
                    </div>
                )}

                {/* 新規ビデオアイコン */}
                {content.visibleNewIcon && (
                    <img
                        src={require("../../../../assets/image/newIcon.svg")}
                        className={styles.newIcon}
                        alt={`newIcon_${content.id}`}
                    />
                )}
                {/* おすすめVideo、Channelの登録（Videoのみ） */}
                {!content.fileType && (
                    <div className={isShowMenu ? styles.showMenu : styles.videoMenu}>
                        <VideoMenu
                            videoId={content.id}
                            setMsg={setMsg}
                            setIsShowing={setShowMenu}
                        />
                    </div>
                )}
            </div>

            <div className={styles.text} onClick={goToContent}>
                <div className={styles.textBody}>
                    <div className={styles.presenter}>
                        <div className={styles.presenterIcon}>
                            <img
                                src={content.professionalImageUrl}
                                className={styles.presenterIcon}
                                alt={content.id}
                                onError={(e) =>
                                    (e.currentTarget.src = require("../../../../../src/assets/image/noPresenterImage.svg"))
                                }
                            />
                        </div>

                        <PuiTypography>
                            {/* {`${content.presenter}`} */}
                            {` ${content.presenter}`}
                        </PuiTypography>
                    </div>

                    <div className={styles.title}>
                        <div
                            className={styles.thumbnailTitle}
                            data-for="title"
                            data-tip={content.title}
                        >
                            <PuiTypography size={20}>{content.title}</PuiTypography>
                        </div>
                    </div>
                    <PuiTooltip id="title" />

                    <div className={styles.description}>
                        <div
                            className={styles.thumbnailDescription}
                            data-for="description"
                            data-tip={content.description}
                        >
                            <PuiTypography>{content.description}</PuiTypography>
                        </div>
                    </div>
                    <PuiTooltip id="description" />
                </div>

                {/* <div className={styles.meta}>
                    {content.tags && content.tags.length > 0 && (
                        <SpacedList>
                            {content.tags.map((tag: VideoTag) => (
                                <SpacedListItem key={tag}>
                                    <Tag tag={tag} />
                                </SpacedListItem>
                            ))}
                        </SpacedList>
                    )}
                </div> */}
            </div>

            {/* <div className={styles.slideBtn}>
                <LibraryBooksIcon style={{color: "var(--red)"}} />
            </div>    */}
        </div>
    );
}

export default memo(FeaturedContentCard);
